const instances = new WeakMap();

function disconnectObserver(observer, el) {
  if (observer) {
    observer.disconnect();
  }
}

function createObserver(el, vnode, modifiers, callback) {
  const observer = new IntersectionObserver(function(entries){
    const entry = entries[0];
    if (entry.isIntersecting) {
      callback();
      if (modifiers.once) {
        disconnectObserver(observer, el);
      }
    }
  });

  // Observe when element is inserted in DOM
  vnode.context.$nextTick(() => observer.observe(el));

  return observer;
}

function bind(el, { value, modifiers }, vnode) {
  if (typeof window.IntersectionObserver !== 'undefined') {
    const observer = createObserver(el, vnode, modifiers, function() {
      const callback = value;
      if (typeof callback === 'function') {
        callback();
      }
    });
    instances.set(el, { observer });
  }
}

function update(el, { value, oldValue }, vnode) {
  if (value === oldValue) {
    return;
  }
  const { observer } = instances.get(el);
  disconnectObserver(observer, el);
  bind(el, { value }, vnode);
}

function unbind(el) {
  if (instances.has(el)) {
    const { observer } = instances.get(el);
    disconnectObserver(observer, el);
    instances.delete(el);
  }
}

export default {
  bind,
  update,
  unbind,
};



// WEBPACK FOOTER //
// ./src/components/pdf/directives/visible.js